export default __webpack_public_path__ + "static/media/class_vii_viii_ix_tab.60523efc.png";